import 'lightgallery/css/lightgallery-bundle.css';
import lightGallery from 'lightgallery';

window.lightGallery = lightGallery;